import axios from "axios";
import { errorHandler } from "./errorHandler";
import _ from "lodash";

export const deleteInventoryArea = (data) => {
  console.log("* utils:deleteInventoryArea init");
  // console.log("[utils:deleteInventoryArea] data: ", data);
  return new Promise(async (resolve, reject) => {
    try {
      let result;
      if (window?.printflo_api) {
        result = await window.printflo_api._deleteInventoryArea(data);
        if (_.isError(result)) throw result;
      } else {
        try {
          const response = await axios.post(`/api/inventory-area/delete`, data);
          result = response.data;
        } catch (error) {
          throw error;
        }
      }
      // console.log("[utils:deleteInventoryArea] result: ", result);
      resolve(result);
    } catch (error) {
      let retval = errorHandler(error);
      // console.log("[utils:submitInventoryArea] retval: ", retval);
      reject(retval);
    }
  });
};

export const getInventoryAreas = (data) => {
  console.log("* utils:getInventoryAreas init");
  return new Promise(async (resolve, reject) => {
    console.log("[utils:getInventoryAreas] data: ", data);
    // if (_.isNil(data?.query?.locationCode)) data.query = {};
    let results;

    try {
      if (window?.printflo_api) {
        results = await window.printflo_api._fetchInventoryAreas(data);
        // console.log(results);
        if (_.isError(results)) throw results;
      } else {
        try {
          const response = await axios.post("/api/inventory-area", data);
          results = response.data;
        } catch (error) {
          throw error;
        }
      }
      resolve(results);
    } catch (error) {
      let retval = errorHandler(error);
      console.log("[utils:getInventoryAreas] retval: ", retval);
      reject(retval);
    }
  });
};

export const submitInventoryArea = (data) => {
  console.log("* utils:submitInventoryArea init");
  return new Promise(async (resolve, reject) => {
    let result;
    try {
      if (window?.printflo_api) {
        result = await window.printflo_api._submitInventoryArea(data);
        if (_.isError(result)) throw result;
      } else {
        try {
          const response = await axios.post("/api/inventory-area/update", data);
          result = response?.data;
        } catch (error) {
          throw error;
        }
      }
      // console.log("[utils:submitInventoryArea] result: ", result);
      resolve(result);
    } catch (error) {
      let retval = errorHandler(error);
      reject(retval);
    }
  });
};

export const searchInventoryAreas = (data) => {
  return new Promise(async (resolve, reject) => {
    let results;
    try {
      if (window?.printflo_api) {
        results = await window.printflo_api._searchInventoryArea(data);
        if (_.isError(results)) throw results;
      } else {
        try {
          const response = await axios.post("/api/inventory-area/search", data);
          results = response?.data;
        } catch (error) {
          throw error;
        }
      }
      resolve(results);
    } catch (error) {
      let retval = errorHandler(error);
      reject(retval);
    }
  });
};
